import { NavLink } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';

export default function AppNavbar() {
  return (
    <Navbar bg="light" variant="light" expand="lg" sticky="top" className="shadow-sm custom-navbar">
      <Container>
        {/* Brand routes to home (which redirects to explore for now); `end` prevents it being active on nested routes */}
        <Navbar.Brand as={NavLink} to="/" end>
          Legislative Congruence Map
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="app-navbar-nav" />
        <Navbar.Collapse id="app-navbar-nav">
          <Nav className="ms-auto">
            {/* TODO: Implement Home page in the future */}
            {/* <Nav.Link as={NavLink} to="/" end>
              Home
            </Nav.Link> */}
            <Nav.Link as={NavLink} to="/" end>
              Explore
            </Nav.Link>
            {/* TODO: Implement About page in the future */}
            <Nav.Link as={NavLink} to="/about">
              About
            </Nav.Link>
            <Nav.Link as={NavLink} to="/team">
              Team
            </Nav.Link>
            {/* TODO: Implement Feedback page in the future */}
            {/* <Nav.Link as={NavLink} to="/feedback">
              Feedback
            </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
